"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureServiceStub = void 0;
const faker_1 = __importDefault(require("faker"));
class FeatureServiceStub {
    isGenerallyAvailable(featureName) {
        return __awaiter(this, void 0, void 0, function* () {
            return { status: true, message: featureName, payload: { isEnabled: faker_1.default.random.boolean() } };
        });
    }
    isFeatureEnabledForUser(companyId, featureName) {
        return __awaiter(this, void 0, void 0, function* () {
            return { status: true, message: featureName, payload: { isEnabled: faker_1.default.random.boolean() } };
        });
    }
}
exports.FeatureServiceStub = FeatureServiceStub;
//# sourceMappingURL=FeatureServiceStub.js.map